import React from 'react';

import { Typography } from '@material-ui/core';
import { Card, CardContent, Grid, Stack, Tooltip, useMediaQuery } from '@mui/material';
import {
  COLOR_PRIMARY,
  COLOR_RANGE_AIRBNB_MARKERS,
  COLOR_TOOLTIP_BACKGROUND,
  exchangeRates,
} from 'src/const';
import { formatCurrency, convertCurrency, abbreviateNumber } from 'src/utils/functions';
import { InfoTooltip } from '../Tooltips';
import { KPI_CARD_COLOR } from 'src/colors';

const MapPointerRevRangeColorCard = ({
  revPotentialRangeInvestment,
  isDisabled,
  currency,
  setIndividualRevenuePotentialRange,
}: {
  revPotentialRangeInvestment: { [key: number]: 'visible' | 'hidden' };
  isDisabled: boolean;
  currency: string;
  setIndividualRevenuePotentialRange;
}) => {
  const GetColorRating = ({
    revPotential,
    index,
    text = true,
    blur = false,
  }: {
    revPotential: number;
    index: number;
    text?: boolean;
    blur?: boolean;
  }) => {
    // size of the color dots
    let sizeValue: number = 10;

    const isTheRevenueInCurrentRevenueRange =
      revPotentialRangeInvestment[revPotential] === 'visible';

    return (
      <Tooltip
        arrow
        title={`
            Average Revenue Potential Range (${((index + 1) / 4) * 100}th Percentile).
            ${isDisabled ? 'Unlock this market to apply this filter.' : ''}
          `}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{
            // background: isTheRevenueInCurrentRevenueRange
            //   ? `${COLOR_RANGE_AIRBNB_MARKERS[index]}40`
            //   : 'transparent',
            background: isTheRevenueInCurrentRevenueRange? KPI_CARD_COLOR : '#fff',
            padding: '5px 10px',
            borderRadius: 200,
            // border: `1px solid ${COLOR_RANGE_AIRBNB_MARKERS[index]}`,
            border: `1px solid ${KPI_CARD_COLOR}`,
            cursor: 'pointer',
            color: isTheRevenueInCurrentRevenueRange? '#fff' : KPI_CARD_COLOR,
          }}
          onClick={() => {
            if (isDisabled) return;

            const tempRevPotentialRange = { ...revPotentialRangeInvestment };

            if (tempRevPotentialRange[revPotential] === 'visible') {
              tempRevPotentialRange[revPotential] = 'hidden';
            } else {
              tempRevPotentialRange[revPotential] = 'visible';
            }

            setIndividualRevenuePotentialRange(tempRevPotentialRange);
            // applyFilter(tempRevPotentialRange, !filterActive);
          }}
        >
          {/* <div
            style={{
              height: sizeValue,
              width: sizeValue,
              minHeight: sizeValue,
              minWidth: sizeValue,
              backgroundColor: COLOR_RANGE_AIRBNB_MARKERS[index],
              borderRadius: '50%',
            }}
          /> */}
          {text && (
            <Typography
              variant="caption"
              component="p"
              style={{ filter: blur ? 'blur(6px)' : 'blur(0)', fontWeight: 'bold' }}
            >
              {'<='} {exchangeRates[currency].symbol}{' '}
              {abbreviateNumber(convertCurrency(currency, revPotential))}
            </Typography>
          )}
        </Stack>
      </Tooltip>
    );
  };

  const matches = useMediaQuery('(max-width:1280px)');

  const revenueChips = () => {
    return Object.keys(revPotentialRangeInvestment)
      .map(Number)
      .sort((a, b) => a - b)
      .map((revPotential, idx) => {
        return <GetColorRating revPotential={revPotential} index={idx} key={idx} />;
      });
  };

  // const foldedRevenueFilterChip = () => {
  //   return (
  //     <>
  //       <InfoTooltip
  //         title={
  //           <Card>
  //             <CardContent style={{ background: '#fff', width: '250px' }}>
  //               <Grid
  //                 container
  //                 justifyContent="space-between"
  //                 alignItems="flex-start"
  //                 xs={12}
  //                 style={{ gap: '20px' }}
  //               >
  //                 {revenueChips()}
  //               </Grid>
  //             </CardContent>
  //           </Card>
  //         }
  //         enterTouchDelay={0}
  //         leaveTouchDelay={10000}
  //       >
  //         <Stack
  //           direction="row"
  //           alignItems="center"
  //           spacing={1}
  //           sx={{
  //             padding: '10px 20px',
  //             borderRadius: 200,
  //             background: COLOR_PRIMARY,
  //             color: '#fff',
  //             boxShadow: '0 0 5px #ccc',
  //             cursor: 'pointer',
  //           }}
  //         >
  //           <Typography variant="body2" component="p" style={{ fontWeight: 'bold' }}>
  //             Revenue Filter &darr;
  //           </Typography>
  //         </Stack>
  //       </InfoTooltip>
  //     </>
  //   );
  // };

  return (
    <>
      <Stack direction="row" alignItems="flex-end" justifyContent="center" sx={{display:'flex', flexWrap:'wrap', justifyContent:'start', gap:2}}>
        {/* {matches ? foldedRevenueFilterChip() : revenueChips()} */}
        {revenueChips()}
      </Stack>
    </>
  );
};

export default MapPointerRevRangeColorCard;
